module.exports = {"410727100":"城关镇","410727101":"黄陵镇","410727102":"黄德镇","410727103":"应举镇","410727104":"陈桥镇","410727105":"赵岗镇","410727106":"留光镇","410727107":"潘店镇","410727108":"李庄镇","410727109":"陈固镇","410727110":"居厢镇","410727111":"鲁岗镇","410727112":"尹岗镇","410727200":"城关乡","410727201":"回族乡","410727202":"王村乡","410727206":"荆宫乡","410727208":"曹岗乡","410727212":"冯村乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410727.json
// module id = 1458
// module chunks = 0